import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableRowDefaultVariants = {
  "state": "default",
  "isActive": false,
  "isSelected": false,
  "showBottomLine": true
}
const tableRowCompoundVariants = []

const tableRowSlotNames = [
  [
    "root",
    "table-row__root"
  ],
  [
    "bottomLine",
    "table-row__bottomLine"
  ],
  [
    "dragHandle",
    "table-row__dragHandle"
  ]
]
const tableRowSlotFns = /* @__PURE__ */ tableRowSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableRowDefaultVariants, getSlotCompoundVariant(tableRowCompoundVariants, slotName))])

const tableRowFn = memo((props = {}) => {
  return Object.fromEntries(tableRowSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableRowVariantKeys = [
  "state",
  "isActive",
  "showBottomLine",
  "isSelected"
]
const getVariantProps = (variants) => ({ ...tableRowDefaultVariants, ...compact(variants) })

export const tableRow = /* @__PURE__ */ Object.assign(tableRowFn, {
  __recipe__: false,
  __name__: 'tableRow',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableRowVariantKeys,
  variantMap: {
  "state": [
    "default",
    "dragging"
  ],
  "isActive": [
    "true",
    "false"
  ],
  "showBottomLine": [
    "true",
    "false"
  ],
  "isSelected": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, tableRowVariantKeys)
  },
  getVariantProps
})